<template>
  <div class="register">
    <app-header head-title="注册"></app-header>
    <div class="registerPart">
      <app-tips></app-tips>
      <div class="banner">
        <div class="center">
          <div class="title-tips">
            <div class="title-line"></div>
          </div>
          <div class="registerDiv">
            <el-form
              ref="registForm"
              :model="registForm"
              :rules="registRules"
              class="register-form"
              autocomplete="on"
              label-position="left"
            >
            <div class="error-code" v-if="captchaError">{{ captchaError }}</div>
              <el-form-item prop="mobile" :error="mobileErrorMsg">
                <el-input
                  ref="mobile"
                  v-model.number="registForm.mobile"
                  placeholder="请输入手机号"
                  name="mobile"
                  autocomplete="off"
                  maxlength="11"
                  @focus="mobileErrorMsg='';captchaError=''"
                />
              </el-form-item>
              <!-- <div class="check-code-div">
                <el-form-item prop="code" class="check-code" ref="code" :error="codeErrorMsg">
                  <el-input
                    v-model.trim="registForm.code"
                    type="text"
                    maxlength="6"
                    placeholder="校验码"
                    name="code"
                  />
                </el-form-item>
                <img
                  ref="imgCode"
                  :src="varHost + 'uc/auth/register/captcha'"
                  @click="imgCodeRefresh()"
                  class="code-img"
                  alt="校验码"
                />
              </div> -->
              <el-form-item
                class="code"
                prop="mobile_verify_code"
                ref="mobile_verify_code"
                :error="phoneCodeErrorMsg"
              >
                <el-input
                  v-model.trim="registForm.mobile_verify_code"
                  placeholder="验证码"
                  name="mobile_verify_code"
                  type="tel"
                  maxlength="6"
                  @keyup.enter.native="handleRegist"
                  autocomplete="new-password"
                  @focus="captchaError=''"
                />
              </el-form-item>
              <el-button
                :class="{'is-timing':able}"
                class="codeBtn"
                :disabled="able"
                type="primary"
                @click="checkPhonePrev()"
              >
                <span v-show="show">获取验证码</span>
                <span v-show="!show">{{count}} s</span>
              </el-button>
              <el-form-item prop="password" class="last">
                <el-input
                  maxlength="16"
                  ref="password"
                  v-model.trim="registForm.password"
                  placeholder="请设置密码"
                  name="password"
                  autocomplete="new-password"
                  :type="pwdSee?'text':'password'"
                />
                <i class="input-icon" :class="{hidden:pwdSee}" @click="showPwd()"></i>
              </el-form-item>
              <div class="agreeMent">
                我已阅读并同意
                <i
                  class="icon"
                  :class="{iconActive:agreeMent}"
                  @click="agreeMent=!agreeMent"
                ></i>
                <!-- <router-link class="showDetails" :to="{name: 'agreement'}">《环球网用户服务条款与隐私保护政策》</router-link> -->
                <a
                  class="showDetails"
                  href="https://i.huanqiu.com/agreement"
                  target="_blank"
                  @click="agreeMent=true"
                >《环球网用户服务条款与隐私保护政策》</a>
              </div>
              <el-button
                :loading="loading"
                class="registerBtn"
                type="primary"
                @click.native.prevent="handleRegist"
              >注册</el-button>

              <div class="backToLogin">
                <p class="left">
                  已有账号，
                  <span class="toLogin" @click="toLogin">点击登录</span>
                </p>
                <p class="right">
                  <router-link target="_blank" :to="{name: 'control'}">
                    <span class="toLogin">家长监控</span>
                  </router-link>
                </p>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<style scoped>
.register .el-button.codeBtn {
  float: right;
  height: 42px;
  margin-top: -60px;
  z-index: 100;
  position: relative;
  padding: 12px 14px;
  background-color: #4981f2;
  color: #fff;
  border-radius: 6px;
  width: 100px;
}
</style>
<script>
import user from "@/api/user";
import header from "@/components/common/header";
import footer from "@/components/common/footer";
import tips from "@/components/common/tips";

export default {
  name: "Regist",
  components: {
    "app-header": header,
    "app-footer": footer,
    "app-tips": tips
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value.toString().length != 11) {
        callback(new Error("手机号格式不正确"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        callback();
      }
    };
    var validateCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入六位图形验证码"));
      } else {
        callback();
      }
    };
    const validatePhoneCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入六位短信验证码"));
      } else {
        callback();
      }
    };
    return {
      registForm: {
        password: "",
        // code: "",
        mobile: "",
        mobile_verify_code: "",
        captcha_result: {
          ticket: "",
          randstr: ""
        }
      },
      registRules: {
        mobile: [
          { required: true, trigger: "blur", validator: validatePhone },
          { type: "number", message: "手机号必须为数字值", trigger: "blur" }
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePass }
        ],
        mobile_verify_code: [
          { required: true, trigger: "blur", validator: validatePhoneCode }
        ],
        code: [{ required: true, trigger: "blur", validator: validateCode }]
      },
      loading: false,
      pwdSee: false,
      redirect: undefined,
      show: true,
      count: "",
      timer: null,
      able: false,
      agreeMent: false,
      mobileErrorMsg: "",
      captchaError: "",
      codeErrorMsg: "",
      phoneCodeErrorMsg: "",
      hasGetCode: false,
      CaptchaAppId: '192261687',
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    },
    registForm: {
      handler: function(n,o) {
      },
      immediate: true
    },
  },
  computed: {},
  created() {
    // this.getCode()
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f3f2f0");
  },
  beforeDestroy() {
    // document.querySelector("body").removeAttribute("style");
  },
  methods: {
    // mobileBlurFn() {
    //   this.$refs["registForm"].validateField("mobile", error => {
    //     if (error) {
    //       return false;
    //     } else {
    //       //校验手机号是否已注册
    //       this.errorMsgEmpty();
    //       user
    //         .registerPhoneCheck({ mobile: this.registForm.mobile })
    //         .then(result => {
    //           if (result.data.code == 1) {
    //             this.mobileErrorMsg = "账号已存在，请直接登录";
    //           }
    //         })
    //         .catch(error => {
    //           this.$nextTick(function() {
    //             typeof error == "string" ? (this.mobileErrorMsg = error) : true;
    //           });
    //         });
    //     }
    //   });
    // },
    checkPhonePrev(){
      let _this = this;
      this.$refs["registForm"].validateField("mobile", error => {
        if (error) {
          return;
        } else {
          _this.getTcaptcha();
        }
      });      
    }, 
    checkPhone() {
      // this.$refs["registForm"].validateField("mobile", error => {
      //   if (error) {
      //     return false;
      //   } else {
      //     this.$refs["registForm"].validateField("code", error => {
      //       if (error) {
      //         return false;
      //       } else {
      //         this.getCode();
      //       }
      //     });
      //   }
      // });
      this.getCode();
    },
    getCode() {
      // 发送请求获取验证码
      this.errorMsgEmpty();
      user
        .getMsgNewRegist({
          mobile: this.registForm.mobile,
          captcha_result: {
            ticket:  this.registForm.captcha_result.ticket,
            randstr:  this.registForm.captcha_result.randstr
          }
          // captcha: this.registForm.code
        })
        .then(response => {
          this.lockGetCode();
          this.hasGetCode = true;
        })
        .catch(error => {
          // this.imgCodeRefresh();
          this.hasGetCode = false;
          this.$nextTick(function() {
            // if (typeof error == "string") {
            //   error == "手机号已存在，请直接用手机号登录"
            //     ? (this.mobileErrorMsg = error)
            //     : (this.codeErrorMsg = error);
            //     this.$Message.info(error);
            // }
            if (typeof error == "string") {
              if(error == '验证码验证失败') {
                this.captchaError = error
              } else if (error == '手机号已存在，请直接用手机号登录') {
                this.mobileErrorMsg = error
              } else if(error == '手机号已被使用'){
                this.mobileErrorMsg = error
              }else {
                this.codeErrorMsg = error
              }
            }
          });
          // this.$refs["code"].resetField();
        });
      // this.imgCodeRefresh();
    },
    showPwd(which) {
      this.pwdSee = !this.pwdSee;
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    errorMsgEmpty() {
      this.mobileErrorMsg = "";
      this.codeErrorMsg = "";
      this.phoneCodeErrorMsg = "";
    },
    lockGetCode() {
      this.able = true;
      // 倒计时
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            this.able = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    toLogin() {
      this.$router.push({ path: "/login" });
    },
    toLogin1() {
      this.$router.push({ path: "/login" });
    },
    // imgCodeRefresh() {
    //   this.$refs.imgCode.src =
    //     this.varHost + "uc/auth/register/captcha?" + Math.random();
    // },
    handleRegist() {
      if (!this.agreeMent) {
        if (document.getElementsByClassName("el-message").length === 0) {
          this.$Message.info("请阅读协议并确认后勾选");
        }
        return;
      }
      this.$refs.registForm.validate(valid => {
        if (valid) {
          //获取验证码校验手机号 后端校验
          this.errorMsgEmpty();
          if (!this.hasGetCode) {
            user
              .getMsgNewRegist({
                mobile: this.registForm.mobile,
                captcha_result: {
                  ticket: this.registForm.captcha_result.ticket,
                  randstr: this.registForm.captcha_result.randstr
                }
                // captcha: this.registForm.code
              })
              .then(response => {
                this.lockGetCode();
                this.codeErrorMsg = "请输入短信验证码";
              })
              .catch(error => {
                // this.imgCodeRefresh();
                this.$nextTick(function() {
                  if (typeof error == "string") {
                    console.log(error);
                    error == "手机号已存在，请直接用手机号登录"
                      ? (this.mobileErrorMsg = error)
                      : (this.codeErrorMsg = error);
                    this.$Message.info(error);
                  }
                });
                // this.$refs["code"].resetField();
              });
          } else {
            //处理注册
            this.loading = true;
            user
              .register(this.registForm)
              .then(response => {
                this.loading = false;
                if (response.data.redirect) {
                  return (location.href = response.data.redirect);
                } else {
                  this.$router.replace({ path: "/index" });
                }
              })
              .catch(error => {
                this.loading = false;
                this.$nextTick(function() {
                  typeof error == "string"
                    ? (this.phoneCodeErrorMsg = error)
                    : true;
                });
                this.$Message.info(error);
                // this.$refs["mobile_verify_code"].resetField();
              });
          }
        }
      });
    },
    getTcaptcha() {
      let _this = this;
      try {
        // 生成一个验证码对象
        let captcha = new TencentCaptcha(this.CaptchaAppId, _this.callback, {});
        // 调用方法，显示验证码
        captcha.show();
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        this.loadErrorCallback();
      }
    },
    callback(res) {
      // console.log('callback:', res);
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      if (res.ret === 0) {
        // 验证成功
          this.registForm.captcha_result.ticket = res.ticket;
          this.registForm.captcha_result.randstr = res.randstr;
          this.checkPhone();
      }else if(res.ret === 2){
        this.registForm.captcha_result.ticket = '';
        this.registForm.captcha_result.randstr = '';
      }
    },
    loadErrorCallback() {
      let appid = this.CaptchaAppId;
      // 生成容灾票据或自行做其它处理
      let ticket = 'terror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
      this.callback({
        ret: -1,
        randstr: '@' + Math.random().toString(36).substr(2),
        ticket: ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error'
      });
    }
  }
};
</script>

<style lang="scss">
/* reset element-ui css */
.register {
  .el-input {
    display: inline-block;
    height: 42px;

    input {
      border: 0px;
      -webkit-appearance: none;
      border-radius: 6px;
      padding: 12px 5px 12px 15px;
      height: 42px;
      line-height: 40px;
    }
  }

  .el-form-item {
    background: #fff;
    border-radius: 6px;
    color: #454545;
    margin-bottom: 18px;
    .input-icon {
      width: 16px;
      height: 10px;
      background: url("../../assets/images/icons.png") no-repeat -78px -22px;
      display: inline-block;
      position: absolute;
      right: 15px;
      top: 16px;
      cursor: pointer;
    }
    .input-icon.hidden {
      background: url("../../assets/images/icons.png") no-repeat -105px -22px;
    }
    .el-form-item__content {
      line-height: 42px;
      height: 42px;
    }
  }
  .el-form-item.code {
    width: 210px;
  }
  .el-form-item.last {
    margin-bottom: 12px;
  }
  .check-code-div {
    width: 210px;
    position: relative;
    .check-code {
      width: 210px;
      .el-input {
        width: 210px;
      }
    }
    .code-img {
      width: 100px;
      height: 36px;
      position: absolute;
      right: -110px;
      top: 1px;
    }
  }
}
</style>

<style lang="scss" scoped>
.register {
  background-color: #f3f2f0;
  width: 100%;
  overflow: hidden;
  .registerPart {
    height: 720px;
    background: url(../../assets/images/RegisterBG.png) repeat-x top;
    position: relative;
    .title-tips {
      position: absolute;
      top: 101px;
      left: 50%;
      z-index: 101;
      margin-left: -200px;
      width: 400px;
      height: 50px;
      background: url(../../assets/images/icons.png) no-repeat 55px -408px;
      .title-line {
        position: absolute;
        bottom: -9px;
        left: 50%;
        z-index: 101;
        margin-left: -100px;
        width: 200px;
        height: 3px;
        background: url(../../assets/images/icons.png) no-repeat -40px -240px;
      }
    }
    .center {
      height: 720px;
      position: relative;
      width: 1000px;
      margin: 0 auto;
    }
    .registerDiv {
      width: 320px;
      margin: 0 auto;
    }
  }

  .register-form {
    position: relative;
    max-width: 100%;
    padding-top: 240px;
    margin: 0 auto;
    overflow: hidden;
  }
  .registerBtn {
    width: 100%;
    height: 46px;
    margin-bottom: 12px;
    background: #4981f2;
    color: #fff;
    border-radius: 6px;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }
  .backToLogin {
    margin-top: 12px;
    font-size: 12px;
    text-align: center;
    p{
      float: left;
    }
    p.right{
      float: right;
    }
    .toLogin {
      color: #4981f2;
      cursor: pointer;
    }
  }
  .agreeMent {
    position: relative;
    margin-bottom: 30px;
    height: 26px;
    padding-left: 22px;
    width: 304px;
    color: #595959;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    letter-spacing: 0px;
    text-align: left;
    .showDetails {
      color: #4981f2;
      text-decoration: none;
    }
    .icon {
      cursor: pointer;
      width: 14px;
      height: 14px;
      position: absolute;
      left: 0px;
      top: 6px;
      background: url(../../assets/images/icons.png) no-repeat -50px -20px;
    }
    .iconActive {
      background: url(../../assets/images/icons.png) no-repeat -20px -20px;
    }
  }
  .error-code {
    font-size: 12px;
    position: absolute;
    top: 345px;
    background: #f5f5f5;
    width:100%;
    z-index: 10000;
    color: #f00;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register/index.vue